import React from 'react';

// Styles & Assets
import styles from './DayMonth.module.css';
import moment from 'moment';

// Interfaces
interface Props {
    day: moment.Moment
    selectedDay: boolean
    thisMonth: boolean
    onclickDay: (d: moment.Moment) => () => void
}

const MAX_SHOWN = 2;

const DayMonth: React.FC<Props> = ({ day, selectedDay, thisMonth, onclickDay }) => {

    const events = [{ id: 0, label: '09:15 Cita Pepa Pérez' }, { id: 1, label: '09:15 Cita Pepa Pérez' }, { id: 2, label: '09:15 Cita Pepa Pérez' }]

    const hiddenCount = events.length - MAX_SHOWN;

    return (
        <div
            key={day.unix()}
            onClick={onclickDay(day)}
            className={`${styles.day} ${thisMonth ? '' : styles.grayBgr} ${selectedDay ? styles.selected : ''}`}
            style={{ borderTop: day.isSame(moment(), 'day') ? '2px solid var(--primary-color)' : '' }}
        >
            <p className={styles.dayMonth}>{day.date()}</p>
            <div className={styles.dayDates}  >
                {events.slice(0, MAX_SHOWN).map(e =>
                    <div key={e.id} className={styles.dateOverview} title={e.label}>
                        <p>{e.label}</p>
                    </div>
                )}
            </div>
            <p className={styles.extra}>
                {hiddenCount > 0 && <span>+{hiddenCount} més</span>}
            </p>
        </div>
    );
};

export default DayMonth;